<template>
  <div class="c-next-step">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VNextStep'
}
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';

.c-next-step {
  background: $color-red;
  color: #fff;
  margin: 3.2rem -2.4rem -2.4rem;
  padding: 3.2rem;

  .c-button {
    margin-bottom: 0;
    margin-top: 2.4rem;
  }
}
</style>
